import React from "react";
import "./index.css";

export class NoMatch extends React.Component {
  render = () => <div>404 error</div>;
}

export default NoMatch;
